import './style.scss';
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {isRTL} from '../../scripts/isRTL';
gsap.registerPlugin(ScrollTrigger)

export function vision_block() {
  const block = document.querySelector('.vision_block');
  if (!block) return;
  const text = block.querySelector('.text-wrapper');
  const img = block.querySelector('.image');
  const imgWrapper = block.querySelector('.image-wrapper');
  const triangle = block.querySelector('.text-wrapper svg');
  
  if (!(img && text)) return;
  const rtl   = isRTL() === 1;   // 0/1 cache
  const sxEnd = rtl ? -1 : 1;    // final scaleX (mirror on RTL)
  const syEnd = 1;               // final scaleY
  const sxFrom = sxEnd * 3;
  const syFrom = syEnd * 3;

// Main timeline: triangle + text stay synced
  gsap.timeline({
    defaults:{ duration: 1.5, ease: 'power2.out' },
    scrollTrigger:{
      trigger: block,
      toggleActions:'play none none none',
      start: 'top center',
      end: 'bottom 20%'
    }
  })
      .addLabel('show-all')
      .fromTo(
          triangle,
          { x: rtl ? '100vw' : '-100vw', y: '-100vh',
            scaleX: sxFrom, scaleY: syFrom, rotation: 0, transformOrigin: '50% 50%' },
          { x: 0, y: 0,
            scaleX: sxEnd,  scaleY: syEnd,  rotation: 0 }
      )
      .from(text, { x: 200, opacity: 0 }, 'show-all');

// Independent ScrollTrigger for the image
  gsap.from(img, {
    yPercent: 100,
    opacity: 0,
    duration: 1.2,
    ease: 'power4.out',
    scrollTrigger: {
      trigger: imgWrapper,
      start: 'top 60%',
      toggleActions: 'play none none none'
    }
  });
  
  
}
